import { useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import forgotCss from "../styles/forgot.module.scss";
import forgotGIF from "../assets/forgot.gif";
import { MdEmail } from "react-icons/md";

function Forgot() {
  const navigate = useNavigate();

  useEffect(() => {
    let token = localStorage.getItem("chatappsessiontoken");
    if (token !== null) {
      navigate("/dashboard");
    }
  }, [navigate]);

  async function forgotValidate(e) {
    e.preventDefault();
    const email = document.querySelector("input");
    const submitBtn = document.querySelector("button");

    submitBtn.style.pointerEvents = "none";
    submitBtn.textContent = "Sending...";

    let { data } = await axios.post(
      "https://chatwave-b-api.onrender.com/genLink",
      {
        email: email.value,
      }
    );

    if (data.status === true) {
      toast.success(data.message, {
        duration: 2500,
        style: { fontFamily: "Poppins" },
      });
    } else if (data.status === false) {
      toast.error(data.message, {
        duration: 2500,
        style: { fontFamily: "Poppins" },
      });
    }
    submitBtn.style.pointerEvents = "auto";
    submitBtn.textContent = "Send Mail";
  }
  return (
    <>
      <Toaster />
      <div className={forgotCss.forgotContainer}>
        <div className={forgotCss.forgotElements}>
          <div className={forgotCss.leftElements}>
            <img src={forgotGIF} alt="forgot-gif" />
          </div>
          <div className={forgotCss.rightElements}>
            <div className={forgotCss.heading}>
              <h1>Forgot Password</h1>
            </div>
            <form
              onSubmit={(e) => {
                forgotValidate(e);
              }}
            >
              <div className={forgotCss.inputs}>
                <div className={forgotCss.input}>
                  <MdEmail />
                  <input
                    type="email"
                    name="email"
                    id="email"
                    placeholder="Email"
                    autoCorrect="off"
                    required
                  />
                </div>
                <div className={forgotCss.submitBtn}>
                  <button type="submit">Send Mail</button>
                </div>
                <div className={forgotCss.other}>
                  <div className={forgotCss.signIn}>
                    <span>Already Registered? </span>
                    <Link to={"/"}>Sign in</Link>
                  </div>
                  <div className={forgotCss.signUp}>
                    <span>New To Chatwave? </span>
                    <Link to={"/register"}>Sign up</Link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Forgot;
